import { render, staticRenderFns } from "./TermsAndConditionsHtml.vue?vue&type=template&id=b850afae&scoped=true"
import script from "./TermsAndConditionsHtml.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsHtml.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsHtml.vue?vue&type=style&index=0&id=b850afae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b850afae",
  null
  
)

export default component.exports